import e from "react";
import l from "classnames";
import t from "./index212.mjs";
const p = ({
  title: s,
  value: m,
  valueStyle: c,
  classes: n,
  description: a,
  dataTestId: o,
  titleId: i
}) => /* @__PURE__ */ e.createElement(
  "div",
  {
    "data-testid": o || "column",
    className: l(n, t.column)
  },
  /* @__PURE__ */ e.createElement("span", { "data-testid": "column-title", className: t.title, id: i }, s),
  /* @__PURE__ */ e.createElement(
    "span",
    {
      "data-testid": "column-value",
      className: l(c, t.value)
    },
    m
  ),
  a ? /* @__PURE__ */ e.createElement("span", { "data-testid": "column-description", className: t.description }, a) : null
);
export {
  p as Column
};
